// extracted by mini-css-extract-plugin
module.exports = {"root":"detail-info-list_root__HVuNg"};